import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import api from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import RatingStars from "@/components/RatingStars";
import { MessageSquare } from "lucide-react";

export default function SupplierReviews() {
  const [data, setData] = useState({ rating: { avg: null, count: 0 }, items: [] });
  useEffect(() => { api.get("/supplier/reviews").then((r) => setData(r.data)).catch(() => {}); }, []);
  return (
    <DashboardLayout title="Buyer reviews">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <Card className="card-lift">
          <CardHeader><CardTitle className="font-heading tracking-tight">Average rating</CardTitle></CardHeader>
          <CardContent>
            <div className="flex items-baseline gap-3">
              <div className="font-heading text-5xl font-black text-primary">{data.rating.avg ? data.rating.avg.toFixed(1) : "—"}</div>
              <div className="text-sm text-muted-foreground">/ 5</div>
            </div>
            <div className="mt-2"><RatingStars value={data.rating.avg || 0} count={data.rating.count} size="md" /></div>
          </CardContent>
        </Card>
        <Card className="card-lift md:col-span-2">
          <CardHeader><CardTitle className="font-heading tracking-tight">Why reviews matter</CardTitle></CardHeader>
          <CardContent className="text-sm text-muted-foreground leading-relaxed">
            Buyer reviews are shown on your public storefront and on every product page, which is the biggest signal European buyers use when choosing between suppliers on Safeway Finland.
            Reply quickly to messages, deliver on the specs you list, and hit your promised lead time — that's what earns 5-star reviews.
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader><CardTitle className="font-heading tracking-tight">All reviews ({data.rating.count})</CardTitle></CardHeader>
        <CardContent>
          {data.items.length === 0 ? (
            <div className="py-10 text-center text-sm text-muted-foreground" data-testid="my-reviews-empty">
              <MessageSquare className="w-8 h-8 mx-auto text-muted-foreground/60" />
              <div className="mt-2">No reviews yet — deliver on a couple of quotes and the ratings will roll in.</div>
            </div>
          ) : (
            <div className="divide-y divide-border">
              {data.items.map((r) => (
                <div key={r.id} className="py-4" data-testid={`my-review-${r.id}`}>
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <div className="font-heading font-bold text-secondary">{r.title || `${r.rating}-star review`}</div>
                      <div className="text-xs text-muted-foreground mt-0.5">{r.buyer_name}{r.buyer_country ? ` · ${r.buyer_country}` : ""} · {new Date(r.created_at).toLocaleDateString()}</div>
                    </div>
                    <RatingStars value={r.rating} showCount={false} />
                  </div>
                  {r.body && <p className="mt-3 text-sm text-muted-foreground whitespace-pre-wrap leading-relaxed">{r.body}</p>}
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
